import { render, staticRenderFns } from "./DrugsCards.vue?vue&type=template&id=b02b1048&"
import script from "./DrugsCards.vue?vue&type=script&lang=js&"
export * from "./DrugsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports